import React, { useEffect, useState, useContext, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  FormGroup,
  Input,
  Label,
  Table,
} from "reactstrap";
import Select from "react-select";
import { resourcesBranchGeo } from "../../../helpers/backend_helper";
import { getStorageUser, getStorageCompany } from "../../../helpers/api_helper";
import {
  Alert,
  ToastHelper,
  DestroyAlertHelper,
} from "../../../helpers/alerts/alertHelper";
import DataTableOnlyHelper from "../../../helpers/tables/DataTableOnlyHelper";
import AddGeoModal from "./AddGeoModal";

const GeofenceModal = ({ modal, setModal }) => {
  const company = getStorageCompany();
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(false);
  const [errors, setErrors] = useState(false);
  const [errorGeneral, setErrorGeneral] = useState(null);
  const [item, setItem] = useState({
    id: null,
    geofence_id: null,
    branch_id: modal.id,
    position: null,
    is_base: false,
    timeOne: 0,
    timeTow: 0,
    timeThree: 0,
    timeFour: 0,
    timeFive: 0,
    timeSix: 0,
    timeSeven: 0,
    timeEight: 0,
    timeNine: 0,
    tolerancy: 0,
  });
  const [newGeo, setNewGeo] = useState({ show: false, update: false });
  const authUser = getStorageUser();
  const handleClose = () => {
    setModal({ ...modal, show: false, id: null });
  };

  const destroy = (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) {
        return;
      }

      setItems(items.filter((i) => i.id != id));
      setEdit(true);
    });
  };

  useEffect(() => {
    const showBranchGeo = async () => {
      const response = await resourcesBranchGeo("show", {}, modal.id);
      setItems(response.data);
    };
    showBranchGeo();
  }, []);

  const timers = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  const dragItem = useRef();
  const dragOverItem = useRef();
  const dragStart = (e, position) => {
    dragItem.current = position;
  };
  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };

  const drop = (e, geo) => {
    let position = dragOverItem.current + 1;
    const copyListItems = [...items];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setItems(copyListItems);
    setEdit(true);
  };

  const handlerOnChange = (e, geo) => {
    const newItem = geo;
    newItem[e.target.name] = e.target.value;
    let array = items.map((item) => (item.id !== newItem.id ? item : newItem));
    setItems(array);
    setEdit(true);
  };

  const changeIsBase = (row) => {
    const newItem = row;
    let array = items.map((item) => {
      item.is_base = (item.id == newItem.id);
      return item;
    });
    setItems(array);
    setEdit(true);
  };

  const save = async () => {
    if (validate()) {
      const response = await resourcesBranchGeo("post", items);
      setEdit(false);
    }
  };

  const validate = () => {
    let errorsNo = 0;
    let base = items.filter((item) => item.is_base == true);
    errorsNo = base.length == 0 ? errorsNo + 1 : errorsNo;
    errorsNo = items.length == 0 ? errorsNo + 1 : errorsNo;
    
    if (errorsNo == 0) {
      setErrorGeneral(null)
      return true;
    }
    setErrorGeneral('Debe agregar almenos 1 geocerca e indicar una geocerca intermedia.')
    return false;
  };

  return (
    <div>
      <Modal
        isOpen={modal.show}
        className="modal-dialog modal-xl"
        role="document"
      >
        <ModalHeader className="bg-primary">{"Geocercas"}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-sm-12 mb-2 text-end">
              <button
                className="btn btn-sm btn-primary pull-right"
                onClick={() => setNewGeo({ ...newGeo, position: items.length, show: true })}
              >
                <i className="fas fa-solid fa-plus"></i> Agregar Geocerca
              </button>
            </div>

            <Table hover>
              <thead>
                <tr>
                  <th></th>
                  <th>Intermedia</th>
                  <th>Geocerca</th>
                  {timers.map((time) => (
                    <th className="text-center" key={time}><small>Tiempo {time}</small></th>
                  ))}
                  <th>Tolerancia</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {items.map((geo, index) => (
                  <tr
                    style={{ textAlign: "center" }}
                    key={index}
                    onDragEnd={(e) => drop(e, geo)}
                    onDragEnter={(e) => dragEnter(e, index)}
                    onDragStart={(e) => dragStart(e, index)}
                    draggable
                  >
                    <td>
                      <i
                        style={{ cursor: "move" }}
                        className="fa fa-bars"
                        aria-hidden="true"
                      ></i>
                    </td>
                    <td className="text-center">
                      <FormGroup>
                        <Input
                          name="base"
                          type="checkbox"
                          onChange={(e) => changeIsBase(geo)}
                          checked={geo.is_base}
                        />
                      </FormGroup>
                    </td>
                    <td>{geo?.alias?.length > 0 ? geo?.alias : geo.geofence_name}</td>
                    <td>
                      <input
                        className="form-control"
                        placeholder={"T1"}
                        name="timeOne"
                        type="text"
                        onChange={(e) => handlerOnChange(e, geo)}
                        value={geo.timeOne}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        placeholder={"T2"}
                        name="timeTow"
                        type="text"
                        onChange={(e) => handlerOnChange(e, geo)}
                        value={geo.timeTow}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        placeholder={"T3"}
                        name="timeThree"
                        type="text"
                        onChange={(e) => handlerOnChange(e, geo)}
                        value={geo.timeThree}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        placeholder={"T4"}
                        name="timeFour"
                        type="text"
                        onChange={(e) => handlerOnChange(e, geo)}
                        value={geo.timeFour}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        placeholder={"T5"}
                        name="timeFive"
                        type="text"
                        onChange={(e) => handlerOnChange(e, geo)}
                        value={geo.timeFive}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        placeholder={"T6"}
                        name="timeSix"
                        type="text"
                        onChange={(e) => handlerOnChange(e, geo)}
                        value={geo.timeSix}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        placeholder={"T7"}
                        name="timeSeven"
                        type="text"
                        onChange={(e) => handlerOnChange(e, geo)}
                        value={geo.timeSeven}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        placeholder={"T8"}
                        name="timeEight"
                        type="text"
                        onChange={(e) => handlerOnChange(e, geo)}
                        value={geo.timeEight}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        placeholder={"T9"}
                        name="timeNine"
                        type="text"
                        onChange={(e) => handlerOnChange(e, geo)}
                        value={geo.timeNine}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        name="tolerancy"
                        type="text"
                        onChange={(e) => handlerOnChange(e, geo)}
                        value={geo.tolerancy}
                      />
                    </td>
                    <td>
                      <div className="d-flex justify-content-between">
                        <div className="p-2">
                          <button
                            className="btn btn-primary btn-sm"
                            title="Editar ramal"
                            onClick={() => [
                              setItem(geo),
                              setNewGeo({
                                ...newGeo,
                                show: true,
                                update: true,
                                idx: index,
                              }),
                            ]}
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                        </div>
                        <div className="p-2">
                          <button
                            className="btn btn-danger btn-sm"
                            title="Eliminar ramal"
                            onClick={() => destroy(geo.id)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          { errorGeneral && 
            <div className="alert alert-warning">{errorGeneral}</div>
          }
        </ModalBody>
        <ModalFooter>
          {edit && (
            <Button color="primary" onClick={save}>
              <i className="fa fa-save"></i> Guardar Cambios
            </Button>
          )}
          <Button color="secondary" onClick={handleClose}>
            <i className="fa fa-times"></i> Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      {newGeo.show && (
        <AddGeoModal
          newGeo={newGeo}
          setNewGeo={setNewGeo}
          setItem={setItem}
          item={item}
          setItems={setItems}
          items={items}
          setEdit={setEdit}
        />
      )}
    </div>
  );
};

export default GeofenceModal;
